import { render } from "./Contato.vue?vue&type=template&id=3bc6a03a&scoped=true"
const script = {}

import "./Contato.vue?vue&type=style&index=0&id=3bc6a03a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\campinasredesdeprotecao\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc6a03a"]])

export default __exports__